import { getMonthToDateRange } from '@/utils/date';
import {
  FILTER_KEYS,
  parseNumberFilter,
  toFilterText,
  toGeoFilterValues,
  toGeoSearch,
  toPeriodFilterValues,
  toPeriodSearch,
} from '@/utils/filters';
import type { LeaveReportSearch } from '../types/leaveReport.types';

type LeaveReportFilterSearch = Omit<LeaveReportSearch, 'search'>;

export function toLeaveReportFilterValues(search: LeaveReportFilterSearch): Record<string, string> {
  return {
    ...toPeriodFilterValues(search, getMonthToDateRange()),
    ...toGeoFilterValues(search),
    [FILTER_KEYS.departmentId]: toFilterText(search.departmentId),
  };
}

export function toLeaveReportFilterSearch(values: Record<string, string>): LeaveReportFilterSearch {
  return {
    ...toPeriodSearch(values),
    ...toGeoSearch(values),
    departmentId: parseNumberFilter(values[FILTER_KEYS.departmentId]),
  };
}
